/*
 * @Author: Potato Knight 1340990981@qq.com
 * @Date: 2023-11-03 16:29:12
 * @LastEditors: Potato Knight 1340990981@qq.com
 * @LastEditTime: 2026-02-05 16:18:18
 * @FilePath: /crm-pc/src/store/moduls/menus.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { reqMainMenus } from '@/api';
import { resultJudge200 } from '@/utlis/facthJudge';

const state = {
    MenusArr: [],
    MenusIndex: 2,
    codeAction: 0,
    isModule:1,
};

const mutations = {
    SETMENUSDATA(state, data) {
        state.MenusArr = data;
    },
    SET_MENUS_INDEX(state, data) {
        state.MenusIndex = data;
    },
    SET_CODE_ACTION(state, data) {
        state.codeAction = data;
    },
    SET_IS_MODULE(state,data){
        state.isModule = data;
    }
};
const actions = {
    /**
     * @description: 获取菜单列表
     * @return {*}
     * @param {*} commit
     */
    async getMainMenus({ commit }) {
        let result = await reqMainMenus();

        if (resultJudge200(result)) {
            commit('SETMENUSDATA', result.data);
        }
    },
};

const getters = {};

export default {
    state,
    mutations,
    actions,
    getters,
};
